import React, { useEffect, useState } from "react";
import { Button, Divider, Input, message, Spin } from "antd";

import IncludedExcludedAudiences from "./IncludedExcludedAudiences";
import ActionItem from "../components/ActionItem";

import arrowLeft from "../../../assets/icons/arrow-left.svg";
import { isNotEmpty } from "../../../utils";
import { controller } from "../controller";
import { IncludeExcludeAudience } from "../CreateBoardFormAutomatedStepTwo";
import ModalAddCreateAudiences from "../ModalAddCreateAudiences";
import CreateActoinModal from "../CreateActoinModal";
import EditActionModal from "../EditActionModal";

export default function AutomatedBoardColumnDetails({ board, setDetailedBoards }) {
  const [listName, setListName] = useState("List Name");
  const [scrollValue, setScrollValue] = useState(0); // This is just for rerendering UI to update the position of the filters, follow the `scrollValue` to understand where and why it used.
  const [actions, setActions] = useState([]);
  const [deleting, setDeleting] = useState(false);
  const [showAudienceModal, setShowAudienceModal] = useState({ type: "", show: false });  
  const [showAddActionModal, setShowAddActionModal] = useState(false); 
  const [showEditModal, setShowEditModal] = useState({id: null, show: false}) 
  const [includeAudiences, setIncludeAudiences] = useState([]);
  const [excludeAudiences, setExcludeAudiences] = useState([]);
  const [allAudiences, setAllAudiences] = useState([])
  const [includeCombLogic, setIncludeCombLogic] = useState("union")
  const [excludeCombLogic, setExcludeCombLogic] = useState("union")
  const [loadingAudience, setLoadingAudience] = useState(false)


  const fetchBoardDetails = async () => {
    try {
      const response = await controller.getBoardDetails(board.id);

      setActions(response.json.campaign.actions)
      setAllAudiences(response.json.campaign.audience_selectors) // this one only contains ids [1,2,3] the other two below contain objects
      setIncludeAudiences(response.json.campaign.audience_selectors_include)
      setExcludeAudiences(response.json.campaign.audience_selectors_exclude)
      setIncludeCombLogic(response.json.campaign.audience_operation_for_included_audience)
      setExcludeCombLogic(response.json.campaign.audience_operation_for_excluded_audience)

    } catch (err) {
      message.error("We could not fetch board details, please check your connection");
      console.error("boardDetails", err);
    } finally {
      // setLoadingActions(false);
    }
  };

  useEffect(() => {
    fetchBoardDetails()
  }, [board, board.campaign, board.campaign.actions, showAddActionModal, showAudienceModal])
  
  const handleIncludeExcludeClick = async (type) => {
    setShowAudienceModal({ type, show: true });
  };

  const handleDelete = async (audienceId) => {
    try {
      setDeleting(true)
      console.log("allAud", allAudiences)
      const selectorsToSend = { campaign: { id: board.campaign.id, audience_selectors: allAudiences.filter(s => s.id ? s.id !== audienceId : s !== audienceId) }};
      const response = await controller.addAudiencSelectorsToBoard(board.id, selectorsToSend);      
      response.status === 204 && message.success(response.message)
      fetchBoardDetails()
    } catch (err) {
      message.error("Something went wrong while deleting the audience")
      console.error("Delete action error", err)
    } finally {
      setDeleting(false)
    }
  }

  const handleDeleteAction = async (actionId) => {
    try {
      setDeleting(true)
      const response = await controller.removeAction(actionId)
      response.status === 204 && message.success(response.message)
      fetchBoardDetails()
    } catch (err) {
      message.error("Something went wrong while deleting the action")
      console.error("Delete action error", err)
    } finally {
      setDeleting(false)
    }
  }

  const handleActionEdit = (actionId) => {
    setShowEditModal({id: actionId, show: true})
  }

  const changeCombinationLogic = async (type, value) => {
    try {
      const combinationLogic = { campaign: { id: board.campaign.id, 
        audience_operation_for_included_audience: type === "included" ? value : includeCombLogic,
        audience_operation_for_excluded_audience: type === "excluded" ? value : excludeCombLogic,
      }};
      setLoadingAudience(true);
      const response = await controller.addAudiencSelectorsToBoard(board.id, combinationLogic);
      message.success("Combination logic changed successfully")

    } catch (err) {
      message.error("We could not send the combination Logic");
      console.error("", err);
    } finally {
      setLoadingAudience(false);
    }
  };

  // useEffect(() => {
  //   changeCombinationLogic();
  // }, [includeCombLogic, excludeCombLogic])

  if (loadingAudience) return(
    <Spin size="large" style={{marginTop: 72}}/>
  )

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: 687,
          width: "100%",
          backgroundColor: "white",
          borderRadius: 10,
          padding: "20px 20px",
          overflowY: "auto",
        }}
        className="custom-scroll"
        onScroll={(e) => setScrollValue(e.target.scrollTop)}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: 20,
              borderBottom: "1px solid #C9C1F1",
              marginBottom: 20,
            }}
          >
            <p style={{ marginBottom: 0, fontSize: 16, fontWeight: "bold" }}>List {board.name}</p>

            <Button style={{ color: "#6B43B5", border: "1px solid #6B43B5" }} onClick={() => setDetailedBoards(false)}>
              <img src={arrowLeft} alt="arrow-left" style={{width: 18, height: 18}}/>
              Back
            </Button>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 30 }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 5 }}>
              <span style={{ fontSize: 16 }}>Status</span>
              <span style={{ backgroundColor: "#EEEDFA", color: "#6B43B5", padding: "3px 10px", borderRadius: 100, fontSize: 12 }}>Automated</span>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 5 }}>
              <span style={{ fontSize: 16 }}>Created Date</span>
              <span style={{ fontSize: 12 }}>{board.created_at.split('T')[0].replace(/-/g, '/')}</span>
            </div>
          </div>

          {/* List Name */}
          <div style={{ width: "100%" }}>
            <Input
              placeholder="List Name"
              style={{ fontSize: 16, padding: "10px 15px", borderRadius: 8 }}
              value={listName}
              onChange={(e) => setListName(e.target.value)}
            />
          </div>

          {/* Audience Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 30 }}>
            <p style={{ fontSize: 16, marginBottom: 0 }}>Audience</p>

            <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
              {isNotEmpty(includeAudiences) ?       
                <IncludedExcludedAudiences audienceType="included" audiences={includeAudiences} scrollValue={scrollValue} onAdd={handleIncludeExcludeClick} onDelete={handleDelete} 
                  setCombLogic={setIncludeCombLogic} combLogic={includeCombLogic} onChangeLogic={changeCombinationLogic}
                />
              :
                <IncludeExcludeAudience type="include" onClick={() => handleIncludeExcludeClick("included")} />
              }
              {/* <Divider style={{ borderColor: "#C9C1F1" }} /> */}
              {isNotEmpty(excludeAudiences) ? 
                <IncludedExcludedAudiences audienceType="excluded" audiences={excludeAudiences} scrollValue={scrollValue} onAdd={handleIncludeExcludeClick} onDelete={handleDelete}
                  setCombLogic={setExcludeCombLogic} combLogic={excludeCombLogic} onChangeLogic={changeCombinationLogic}              
                />
              :
                <IncludeExcludeAudience type="exclude" onClick={() => handleIncludeExcludeClick("excluded")} />            
              }
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: "flex", flexDirection: "column", gap: 15, marginTop: 30 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
              <p style={{ marginBottom: 0, fontSize: 16 }}>Action</p>

              <Button type="primary" style={{ fontSize: 12 }} onClick={() => setShowAddActionModal(true)}>
                Add Action
              </Button>
            </div>

            {isNotEmpty(actions) && (
              <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                {actions.map((action) => <ActionItem action={action} onDelete={handleDeleteAction} deleting={deleting} onEdit={handleActionEdit}/>)}
              </div>
            )}
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 15, marginTop: 30, width: "100%" }}>
            <Button style={{ padding: "20px 0", fontSize: 14 }} type="primary">
              Save Changes
            </Button>

            <Button style={{ padding: "20px 0", color: "#6B43B5", border: "1px solid #6B43B5", fontSize: 14 }}>Delete List</Button>
          </div>
        </div>
      </div>

      {showAudienceModal.show && 
        <ModalAddCreateAudiences
          showAudienceModal={showAudienceModal}
          setShowAudienceModal={setShowAudienceModal}
          boardId={board.id}
          campaignId={board.campaign.id}
          selectedAudiences={allAudiences}
          setSelectedAudiences={setAllAudiences}
          getBoardDetails={fetchBoardDetails}
          selectedIncludeOrExudeAudiences={showAudienceModal.type === "included" ? includeAudiences : excludeAudiences}
          setSelectedIncludeOrExcludeAudiences={showAudienceModal.type === "included" ? setIncludeAudiences : setExcludeAudiences}

        />
      }
      {showAddActionModal && 
        <CreateActoinModal showAddActionModal={showAddActionModal} setShowAddActionModal={setShowAddActionModal} campaignId={board.campaign.id} boardId={board.id} actions={actions}/>
      }

        
      {showEditModal.show &&
        <EditActionModal show={showEditModal} setShow={setShowEditModal} actions={actions} onEditDone={fetchBoardDetails}/>
      }
     
    </>
  );
}
